import { mount } from "svelte";
import App from "./App.svelte";
import { handleCallback } from "./api";
import "maplibre-gl/dist/maplibre-gl.css";
import "./app.css";

handleCallback()
  .catch((e) => console.error("[auth] callback failed", e))
  .finally(() => mount(App, { target: document.getElementById("app")! }));
